import DOMPurify from 'isomorphic-dompurify';

// A link that opens another tab gets no hold on the dashboard's window
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.hasAttribute?.('target')) {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

/**
 * HTML from apps, themes and partners without its scripts, its links
 * keeping the tab they open in
 * @param {string} html
 * @returns {string}
 */
export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html, { ADD_ATTR: ['target'] });
}
